module.exports = __webpack_public_path__ + "static/SW2-d4b03f9e2faac78668841a667ee1bece.png";